import { createStore } from "./store.js";

export interface AppState {
}

export const app = createStore<AppState>({
});
